<template>
  <div class="sk-forgot-page">
    <div class="sk-topbar">
      <a href="#" class="sk-logo" @click.prevent>
        <img src="https://sentrykit.com/wp-content/uploads/2026/04/Sk-2.0-logo-white.png" alt="SentryKit" style="height:48px;width:auto;display:block;">
      </a>
    </div>

    <div class="sk-main">
      <div class="sk-card">
        <div class="sk-card-header">
          <h2>Reset your password</h2>
          <p>Enter your email address and we'll send you a link to reset your password.</p>
        </div>

        <div v-if="response === 200" class="sk-success-msg">
          <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
          Password reset email has been sent. Check your inbox.
        </div>

        <div v-if="response !== null && response !== 200" class="sk-error-msg">
          <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor"><circle cx="12" cy="12" r="10" stroke-width="2"/><path stroke-width="2" d="M12 8v4m0 4h.01"/></svg>
          {{ response === 404 ? 'We could not find this email address in our database.' : 'There was a problem sending the reset email. Please try again.' }}
        </div>

        <form @submit.prevent="sendPasswordResetEmail">
          <div class="sk-form-row">
            <div class="sk-field">
              <label>Email Address <span class="req">*</span></label>
              <input class="sk-input" type="email" v-model="email" placeholder="you@company.com" required autofocus>
            </div>
          </div>

          <button type="submit" class="sk-btn sk-btn-primary sk-mt-6" :class="{ loading: working }" :disabled="working || sent">
            <span v-if="working" class="sk-spinner"></span>
            <span v-else>{{ sent ? 'Email Sent ✓' : 'Send Reset Link →' }}</span>
          </button>
        </form>

        <div class="sk-login-link">Remember your password? <router-link to="/login">Log in</router-link></div>
      </div>
    </div>
  </div>
</template>

<script>
import './styles/signup-flow.css'

export default {
  data: function () {
    return {
      email: '',
      response: null,
      working: false,
      sent: false
    }
  },
  methods: {
    sendPasswordResetEmail: function () {
      if (!this.email) return
      this.working = true
      this.response = null
      this.$http.post('/api/auth/sendpasswordresetemail', {
        email: this.email
      }).then(
        (response) => {
          this.response = response.status
          this.working = false
          this.sent = true
        },
        (response) => {
          this.response = response.status
          this.working = false
          setTimeout(() => { this.response = null }, 4000)
        }
      )
    }
  }
}
</script>

<style scoped>
.sk-forgot-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Roboto', 'DM Sans', -apple-system, sans-serif;
  -webkit-font-smoothing: antialiased;
}

.sk-success-msg {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 13px;
  color: #166534;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>



// WEBPACK FOOTER //
// ForgotPasswordPage.vue?7d724226